import Immutable from 'immutable';

import {
	// webapi,
	createModuleState,
	createModelForState,
	// REPORTED_EXCEPTION,
	// StaticLookup,
	// setPreference,
	getPreference,
} from 'ps-gui';
import {
	createSearchModel,
	getSqlFulltextFilter,
	// parseRoleId
} from '../utils';
import RecordingProtocolDetailModel from './recordingprotocoldetailmodel';
// import { getLookup } from '../../data/lookup';
import { getPhrase } from '../../data/phrases';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('RecordingProtocolAdmin');


export default class RecordingProtocolAdminModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setProperty(name, value) {
		if (Array.isArray(name)) {
			return new RecordingProtocolAdminModel(this.#data.setIn(name, value));
		} else {
			return new RecordingProtocolAdminModel(this.#data.set(name, value));
		}
	}

	#updateTabs() {
		let tabs = baseTabs;
		if (this.#data.get('recordingProtocolDetail')) {
			tabs = tabs.push(Immutable.Map({
				id: 'recordingProtocolDetail',
				text: '#'
			}));
		}
		return this.#setProperty('tabs', tabs);
	}

	closeRecordingProtocolDetail() {
		const recordingProtocolDetailOpenedFromTab = this.#data.get('recordingProtocolDetailOpenedFromTab');
		let model = this.#setProperty('recordingProtocolDetail', null);
		if (recordingProtocolDetailOpenedFromTab) {
			model = model.setSelectedTabId(recordingProtocolDetailOpenedFromTab);
		}
		return model.#updateTabs();
	}

	async loadRecordingProtocolDetail(id) {
		let rpm = new RecordingProtocolDetailModel();
		rpm = rpm.setAdminMode(true);
		rpm = await rpm.load(id);
		return this
			.#setProperty('recordingProtocolDetail', rpm.getState())
			.#setProperty('recordingProtocolDetailOpenedFromTab', this.#data.get('selectedTabId') || 'recordingProtocols')
			.#updateTabs()
			.#setProperty('selectedTabId', 'recordingProtocolDetail');
	}

	setSelectedTabId(value) {
		return this.#setProperty('selectedTabId', value);
	}

	setPartyId(partyId) {
		console.log('setPartyId', partyId);
		return this.#setProperty('partyId', partyId);
	}

	async checkGlobalContextChange(globalContext) {
		if (!globalContext) {
			return this;
		}
		const gcLangId = globalContext.getLanguageId();
		const langId = this.#data.get('langId');
		if (gcLangId === langId) {
			return this;
		}
		return (await this.initialize(globalContext)).#setProperty('languageTimestamp', new Date().getTime()).#updateTabs();
	}

	getLanguageTimestamp() {
		return this.#data.get('languageTimestamp') || 0;
	}


	setRoleId(roleId) {
		let model = this.#setProperty('roleId', roleId);
		let dp = this.#data.get('distributionPeriodLookup.' + roleId);
		if (dp) {
			model = model.setDistributionPeriodId(dp.getItems().getIn([0, 'key']));
		}
		return model;
	}

	setDistributionPeriodId(value) {
		return this.#setProperty('distributionPeriodId', value);
	}

	#getPreferenceKeyBase() {
		return '//myrec//';
	}

	#getExtFilterPreferenceKey() {
		return this.#getPreferenceKeyBase() + 'extFilter';
	}

	initializePreferences() {
		let data = this.#data;
		let ef = getPreference(this.#getExtFilterPreferenceKey());
		if (!ef) {
			return this;
		}
		if (ef.get('sources')) {
			data = data.set('sources', ef.get('sources'));
		}
		return new RecordingProtocolAdminModel(data);
	}

	async initialize(globalContext) {
		let model = this;

		let srch = createSearchModel('/api/dq/sv_admin_recording_protocol_submission').setProcessFilter(processSearchFilter).setEntityName('recordingProtocol');
		srch = srch.setOutput(getRecordingProtocolSearchOutputColumns());
		srch = srch.initializePreferences();
		model = model.setRecordingProtocolSearch(srch);

		model = model.initializePreferences();
		return model.#setProperty('langId', globalContext.getLanguageId());
	}

	async refreshSearch() {
		return this.setRecordingProtocolSearch(await this.getRecordingProtocolSearch().search());
	}

	setRecordingProtocolSearch(model) {
		return new RecordingProtocolAdminModel(this.#data.set('recordingProtocolSearch', model.getState()));
	}

	getRecordingProtocolSearch() {
		return createModelForState(this.#data.get('recordingProtocolSearch'));
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}

function processSearchFilter(filter) {
	if (filter.recording) {
		filter.recording = getSqlFulltextFilter(filter.recording);
	}
	if (filter.role_id) {
		filter.party_id = filter.role_id;
		filter.role_id = null;
		/*var pr = parseRoleId(filter.role_id);
		filter.party_id = pr.partyId;
		filter.role_type_id = pr.roleTypeId;*/
	}
	return filter;
}


export function getRecordingProtocolSearchOutputColumns() {
	return [
		'submission_id',
		'recording',
		'role_id',
		'main_artist',
		'production_release_year',
		'length',
		'audio_video',
		'isrc',
		'submission_type',
		'submission_status',
		'last_modified'
	];
}

const baseTabs = Immutable.fromJS([{
	id: 'recordingProtocols',
	text: () => getPhrase('recordingProtocols')
}]);
